"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authApi = void 0;
/** @deprecated 해당 API는 deprecated되었으니 SSO Auth Token API를 호출하세요. */
const createAuthToken = {
    method: "POST",
    url: "/tokens",
    reducer: resp => resp,
    errReducer: resp => resp,
};
/** @deprecated 해당 API는 deprecated되었으니 SSO Auth Token API를 호출하세요. */
const awakeAuthToken = {
    method: "POST",
    url: "/tokens/heartbeat",
    reducer: resp => resp,
    errReducer: resp => resp,
};
/** @deprecated 해당 API는 deprecated되었으니 SSO Auth Token API를 호출하세요. */
const refreshAuthToken = {
    method: "POST",
    url: "/token/refresh",
    reducer: resp => resp,
    errReducer: resp => resp,
};
/** @deprecated 해당 API는 deprecated되었으니 SSO Auth Token API를 호출하세요. */
const deleteAuthToken = {
    method: "DELETE",
    url: "/tokens",
    reducer: resp => resp,
    errReducer: resp => resp,
};
/** @deprecated 해당 API는 deprecated되었으니 SSO Request Token API를 호출하세요. */
const createRequestToken = {
    method: "POST",
    url: "/request-tokens",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const createESignToken = {
    method: "POST",
    url: "/e-sign-tokens",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const decryptESignToken = {
    method: "POST",
    url: "/e-sign-token/decrypt",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getPaginatableAuthTokens = {
    method: "GET",
    url: "/my/login-histories",
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.authApi = {
    createAuthToken,
    awakeAuthToken,
    refreshAuthToken,
    deleteAuthToken,
    createRequestToken,
    createESignToken,
    decryptESignToken,
    getPaginatableAuthTokens,
};
//# sourceMappingURL=auth.js.map